export default __webpack_public_path__ + "assets/images/7e1898645c8806163f9f523dbfa64f2c.png";